import React from "react";
import {
  MDBIcon,
  MDBNavbar,
  MDBDropdownToggle,
  MDBDropdown,
  MDBDropdownMenu,
  MDBNavbarBrand
} from "mdbreact";
import Toggle from "../toggle";
import { useSelector } from "react-redux";
import CardUser from "../Cards/CardUser";
export default function Navbar({ onClick, title, urlImg }) {
 

  return (
    <MDBNavbar expand="lg">
      {title && urlImg && (
        <MDBNavbarBrand>
          <img src={urlImg} alt="" />
          <div className="title">
            <p> {title}</p>
          </div>
        </MDBNavbarBrand>
      )}
      <div className="items">
        <Toggle onClick={onClick} />
      </div>
    </MDBNavbar>
  );
}
